import React from "react";
import Card from "components/card";
import { api } from "utils/api";

export default function Equipe() {
  const [admins, setAdmins] = React.useState([]);
  const [meuId, setMeuId] = React.useState(null);
  const [carregando, setCarregando] = React.useState(true);
  const [executando, setExecutando] = React.useState(false);
  const [erro, setErro] = React.useState("");

  const [nome, setNome] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [senha, setSenha] = React.useState("");

  const carregar = React.useCallback(async () => {
    setCarregando(true);
    const [me, lista] = await Promise.all([api("/api/admin/me"), api("/api/admin/equipe")]);
    if (me && me.success) setMeuId(me.admin.id);
    if (lista && lista.success) setAdmins(lista.admins);
    setCarregando(false);
  }, []);

  React.useEffect(() => {
    carregar();
  }, [carregar]);

  async function adicionarMembro(e) {
    e.preventDefault();
    setErro("");
    setExecutando(true);
    try {
      const data = await api("/api/admin/equipe", {
        method: "POST",
        body: JSON.stringify({ nome: nome.trim(), email: email.trim(), senha }),
      });
      if (!data) return;
      if (!data.success) {
        setErro(data.error || "Não foi possível adicionar.");
        return;
      }
      setNome("");
      setEmail("");
      setSenha("");
      await carregar();
    } finally {
      setExecutando(false);
    }
  }

  async function alternarStatus(admin) {
    const acao = admin.ativo === "Sim" ? "desativar" : "ativar";
    if (acao === "desativar" && !window.confirm(`Desativar o acesso de ${admin.nome}?`)) return;
    const data = await api(`/api/admin/equipe/${admin.id}/${acao}`, { method: "POST" });
    if (!data) return;
    if (!data.success) {
      alert(data.error || "Não foi possível concluir.");
      return;
    }
    await carregar();
  }

  return (
    <div>
      <Card extra="mt-3 w-full p-4">
        <h5 className="mb-4 text-base font-bold text-navy-700 dark:text-white">Adicionar membro à equipe</h5>
        {erro && (
          <div className="mb-3 rounded-xl border border-red-400 bg-red-50 px-3 py-2 text-sm text-red-600 dark:border-red-400 dark:bg-navy-800 dark:text-red-300">
            {erro}
          </div>
        )}
        <form className="grid grid-cols-1 gap-3 md:grid-cols-4" onSubmit={adicionarMembro}>
          <input
            type="text"
            placeholder="Nome completo"
            className="h-10 rounded-xl border border-gray-200 bg-white/0 px-3 text-sm dark:!border-white/10 dark:text-white"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="E-mail"
            className="h-10 rounded-xl border border-gray-200 bg-white/0 px-3 text-sm dark:!border-white/10 dark:text-white"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha (mín. 8 caracteres)"
            className="h-10 rounded-xl border border-gray-200 bg-white/0 px-3 text-sm dark:!border-white/10 dark:text-white"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            minLength={8}
            required
          />
          <button
            type="submit"
            disabled={executando}
            className="h-10 rounded-xl bg-brand-500 px-4 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50 dark:bg-brand-400"
          >
            {executando ? "Adicionando..." : "Adicionar"}
          </button>
        </form>
      </Card>

      <Card extra="mt-5 w-full px-4 pb-4">
        <h5 className="mb-2 mt-4 text-base font-bold text-navy-700 dark:text-white">Equipe interna</h5>
        <div className="mt-2 overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="!border-px !border-gray-200 dark:!border-white/10">
                <th className="border-b border-gray-200 pb-2 pt-4 pr-4 text-start text-xs font-bold text-gray-600 dark:border-white/10 dark:text-white">NOME</th>
                <th className="border-b border-gray-200 pb-2 pt-4 pr-4 text-start text-xs font-bold text-gray-600 dark:border-white/10 dark:text-white">E-MAIL</th>
                <th className="border-b border-gray-200 pb-2 pt-4 pr-4 text-start text-xs font-bold text-gray-600 dark:border-white/10 dark:text-white">STATUS</th>
                <th className="border-b border-gray-200 pb-2 pt-4 pr-4 text-start text-xs font-bold text-gray-600 dark:border-white/10 dark:text-white">DESDE</th>
                <th className="border-b border-gray-200 pb-2 pt-4 pr-4 dark:border-white/10"></th>
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-gray-500">Carregando...</td>
                </tr>
              ) : admins.length === 0 ? (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-gray-500">Nenhum membro cadastrado.</td>
                </tr>
              ) : (
                admins.map((a) => (
                  <tr key={a.id}>
                    <td className="min-w-[120px] border-white/0 py-3 pr-4 text-sm font-bold text-navy-700 dark:text-white">
                      {a.nome} {a.id === meuId && <span className="text-xs font-normal text-gray-500">(você)</span>}
                    </td>
                    <td className="min-w-[120px] border-white/0 py-3 pr-4 text-sm text-navy-700 dark:text-white">{a.email}</td>
                    <td className="min-w-[100px] border-white/0 py-3 pr-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${
                          a.ativo === "Sim"
                            ? "bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300"
                            : "bg-gray-200 text-gray-700 dark:bg-white/10 dark:text-gray-300"
                        }`}
                      >
                        {a.ativo === "Sim" ? "Ativo" : "Inativo"}
                      </span>
                    </td>
                    <td className="min-w-[100px] border-white/0 py-3 pr-4 text-sm text-navy-700 dark:text-white">
                      {new Date(a.criado_em).toLocaleDateString("pt-BR")}
                    </td>
                    <td className="min-w-[100px] border-white/0 py-3 pr-4">
                      {a.id === meuId ? null : (
                        <button
                          onClick={() => alternarStatus(a)}
                          className={`rounded-xl border px-3 py-1 text-xs font-medium ${
                            a.ativo === "Sim"
                              ? "border-red-400 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
                              : "border-green-400 text-green-600 hover:bg-green-50 dark:hover:bg-green-500/10"
                          }`}
                        >
                          {a.ativo === "Sim" ? "Desativar" : "Reativar"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
